import React, { useState, useEffect } from "react";
import axios from 'axios';
import toast from 'react-hot-toast';
import { useTranslation } from "react-i18next";
import { Card, Spinner, Container, Row, Col, Modal } from "react-bootstrap";
import { getToken } from "../../../utils/auth";

function QRHeroProfile(userUid) {
    const [allQR, setAllQR] = useState([]);
    const { t } = useTranslation();
    const [fetching, setFetching] = useState(false);
    const [qrPopupOpen, setQrPopupOpen] = useState(false);
    const [qrImageUrl, setQrImageUrl] = useState('');

    const handleQrClick = (imageUrl) => {
        setQrImageUrl(imageUrl);
        setQrPopupOpen(true);
    };

    const closeQrPopup = () => {
        setQrPopupOpen(false);
    };

    const fetchReservations = async () => {
        setFetching(true);
        try {
            const token = getToken();
            const response = await axios.get(
                `${process.env.REACT_APP_URL}/api/qrc/social-net/all?UID=${userUid.userUid}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );
            setAllQR(response.data?.data || []);
        } catch (error) {
            toast.error(error?.response?.data?.message || "Failed to fetch QR Hero.");
        } finally {
            setFetching(false);
        }
    };

    useEffect(() => {
        fetchReservations();
    }, []);

    const formatCategory = (category) => {
        if (category === "file") return "File";
        if (category === "v-card") return "vCard";
        if (category === "url") return "URL";
        return category || "N/A";
    };

    return (
        <Container className="" >
            <div>
                <Col lg={12}>
                    {fetching ? (
                        <Spinner animation="border" role="status">
                            <span className="sr-only">{t('query_loading')}</span>
                        </Spinner>
                    ) : (
                        allQR && allQR.length > 0 ? (
                            allQR.map((reservation) => (
                                <Card key={reservation?._id} className="shadow-sm mb-3">
                                    <Row className="g-0 align-items-center shadow">
                                        <Col xs={12} md={9}>
                                            <Card.Body>
                                                <h5>{t('qrc_UID')}: {reservation?.qrc_UID}</h5>
                                                <div className="mt-2">{t('category')}: {formatCategory(reservation?.qrcCategory || reservation?.__t)}</div>
                                                <div className="mt-2">
                                                    {t('content')}: {reservation?.staticContent ? (
                                                        <a
                                                            href={reservation.staticContent}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            style={{ color: "blue", textDecoration: "underline" }}
                                                        >
                                                            {reservation.staticContent}
                                                        </a>
                                                    ) : "N/A"}
                                                </div>
                                            </Card.Body>
                                        </Col>
                                        {reservation?.qrCodeUrl && (
                                            <Col xs={12} md={3} className="text-center">
                                                <img
                                                    className="img-fluid"
                                                    onClick={() => handleQrClick(reservation?.qrCodeUrl)}
                                                    src={reservation?.qrCodeUrl}
                                                    alt="QR Code"
                                                    style={{ maxWidth: '120px', height: 'auto', cursor: "pointer", margin: '10px auto' }}
                                                />
                                            </Col>
                                        )}
                                    </Row>
                                </Card>
                            ))
                        ) : (
                            <Col lg={12}>
                                <Card>
                                    <Card.Body>
                                        <div style={{ justifyContent: "center", textAlign: "center" }}>
                                            {t('no_qrc_list')}
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                        )
                    )}
                </Col>
            </div>

            <Modal
                size="sm"
                className="fade"
                id="qr-modal"
                onHide={closeQrPopup}
                show={qrPopupOpen}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>QR Code</Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center">
                    <img
                        src={qrImageUrl}
                        alt="QR Code"
                        style={{ maxWidth: "200px", height: "auto", marginBottom: "20px" }}
                    />
                </Modal.Body>
                <Modal.Footer style={{ display: "flex", justifyContent: "center" }}>
                    {qrImageUrl && (
                        <button
                            className="btn btn-primary"
                            onClick={() => {
                                const link = document.createElement("a");
                                link.href = qrImageUrl;
                                link.download = "QR_Code.png";
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);
                            }}
                        >
                            Download
                        </button>
                    )}
                    <button className="btn btn-secondary" onClick={closeQrPopup}>
                        Close
                    </button>
                </Modal.Footer>
            </Modal>
        </Container>
    );
}

export default QRHeroProfile;
